import { useState, useEffect, useRef } from "react";
import { Offcanvas, Row, Col, Form, Button } from "react-bootstrap";
import useFetchData from "./useFetchDatav2";

import { DayPicker } from "react-day-picker";
import "../css/dayPickerStyle.css";

import { FaGripLinesVertical, FaNotEqual, FaEquals, FaTimes, FaSearchPlus, FaSearchMinus, FaCompress, FaRegFilePdf, FaRegStar, FaArrowUp, FaArrowDown, FaArrowLeft, FaFlag, FaRegFlag, FaArrowRight, FaDotCircle } from "react-icons/fa";
import { format, parseISO, startOfDay } from "date-fns";
import { Document, Page } from "react-pdf";
import FollowUpModal from "./FollowUp";
import CurrencyInput from "./CurrencyInput";
import { useToast } from "../Context/useToast";

import FlagDropdown from "./FlagDropDown";
import "./ReconcileInvoiceStatementPdfModal.css";
import useElementWidthObserver from "./useElementWidthObserver";
// Development Set the workerSrc property for pdf.js
//pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();
//Production
//pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

const ReconcileInvoiceStatementPdfModal = ({ isEdit, imageData, propScale, filteredReconIndex, setfilteredReconIndex, filteredRecon, documentGrade = "-", originalPageNumber, onCloseModal, onUpdateReconData, onFollowUpStatusChange }) => {
   const [isLoading, setIsLoading] = useState(true);
   const { triggerToast } = useToast();
   const [showFollowup, setShowFollowup] = useState(false); //for followup offcanvas
   const [scale, setScale] = useState(propScale || 1.0);
   const [pageNo, setPageNo] = useState(filteredRecon[filteredReconIndex]?.sd_page_no || 1);
   const [supplierDetailID, setSupplierDetailId] = useState(filteredRecon[filteredReconIndex]?.sd_id || null);
   const [statementID, setStatementId] = useState(filteredRecon[filteredReconIndex]?.s_id || null);
   const [externalSourceHeaderID, setExternalSourceHeaderId] = useState(filteredRecon[filteredReconIndex]?.en_id || null);
   const [hasFollowUp, setHasFollowUp] = useState(filteredRecon[filteredReconIndex]?.has_active_followup || false);
   const [matchStatus, setMatchStatus] = useState(filteredRecon[filteredReconIndex]?.match_status || null);
   const [normalizedVertices, setNormalizedVertices] = useState(
      filteredRecon[filteredReconIndex]?.sd_invoice_date_obj?.normalized_vertices || {}
   );
   const [showCalendar, setShowCalendar] = useState(false);
   const supplierDatePickerRef = useRef(null);

   const supplierInvoiceNumberRef = useRef("");
   const supplierPONumberRef = useRef("");
   const externalInvoiceNumberRef = useRef("");
   const externalPONumberRef = useRef("");
   const supplierInvoiceAmountRef = useRef("");
   const externalInvoiceAmountRef = useRef("");
   const ignoreSupplierRef = useRef("");
   const ignoreEntryRef = useRef("");
   // react datepick uses useState
   const [supplierInvoiceDate, setSupplierInvoiceDate] = useState(null);
   const [externalInvoiceDate, setExternalInvoiceDate] = useState(null);
   const supplierInvoiceDateRef = useRef("");
   const externalInvoiceDateRef = useRef("");

   const [numPages, setNumPages] = useState(null);
   const [selectedFlag, setSelectedFlag] = useState(1);
   const [currentPage, setCurrentPage] = useState(1);
   const [pageDimensions, setPageDimensions] = useState({ width: 0, height: 0 });
   const [canvasOffset, setCanvasOffset] = useState({ left: 0, top: 0 });
   
   // Form state for controlled inputs
   const [formData, setFormData] = useState({
      supplierInvoiceNumber: "",
      supplierPONumber: "",
      supplierInvoiceAmount: "",
      externalInvoiceNumber: "",
      externalPONumber: "",
      externalInvoiceAmount: "",
      ignoreSupplier: false,
      ignoreEntry: false,
   });
   const offcanvasRef = useRef(null); //Ref to the Offcanvas
   const canvasRef = useRef(null); //Ref to the canvas (pdf)
   const scrollRef = useRef(0);
   const boxPositionRef = useRef({ top: 0, left: 0, width: 0, height: 0 });
   const [boxPosition, setBoxPosition] = useState({ top: 0, left: 0, width: 0, height: 0 });

   const headerColWidthRef = useRef(null);
   const isHeaderColWidth = useElementWidthObserver(headerColWidthRef, 700); // Hide if less than 700px

   const displayedPages = calculateDisplayedPages(currentPage, numPages);
   const [show, setShow] = useState(true);
   const [isDragging, setIsDragging] = useState(false);
   const dragRef = useRef(null);
   const { fetchData } = useFetchData();

   //default width when offcanvas opens
   const [width, setWidth] = useState(window.innerWidth * 0.6);

   //For protractor invoice input elements
   const readOnlyStyle = {
      backgroundColor: "var(--rk-surface-subtle)",
      cursor: "not-allowed",
   };

   useEffect(() => {
      if (filteredReconIndex !== null && filteredRecon?.[filteredReconIndex]) {
         const data = filteredRecon[filteredReconIndex];

         setSupplierDetailId(data.sd_id);
         setExternalSourceHeaderId(data.en_id);
         setMatchStatus(data.match_status);

         // Update form state with new data
         setFormData({
            supplierInvoiceNumber: data.sd_parsed_invoice_no || data.sd_invoice_no || "",
            supplierPONumber: data.sd_po_no || "",
            supplierInvoiceAmount: data.sd_amount?.toFixed(2) ?? "",
            externalInvoiceNumber: data.en_invoice_id || "",
            externalPONumber: data.en_pono || "",
            externalInvoiceAmount: data.en_invoice_amount?.toFixed(2) ?? "",
            ignoreSupplier: data.sd_ignored || false,
            ignoreEntry: data.en_ignore || false,
         });

         // Update date inputs
         const parsedSupplierDate = parseDate(data.sd_invoice_date);
         setSupplierInvoiceDate(parsedSupplierDate);
         supplierInvoiceDateRef.current = data.sd_invoice_date || "";

         setExternalInvoiceDate(data.en_invoice_date);
         externalInvoiceDateRef.current = data.en_invoice_date || "";

         // Update refs for form submission
         supplierInvoiceNumberRef.current = data.sd_parsed_invoice_no || data.sd_invoice_no || "";
         supplierPONumberRef.current = data.sd_po_no || "";
         externalInvoiceNumberRef.current = data.en_invoice_id || "";
         externalPONumberRef.current = data.en_pono || "";
         supplierInvoiceAmountRef.current = data.sd_amount?.toFixed(2) ?? "";
         externalInvoiceAmountRef.current = data.en_invoice_amount?.toFixed(2) ?? "";
         ignoreSupplierRef.current = data.sd_ignored || false;
         ignoreEntryRef.current = data.en_ignore || false;
      }
   }, [filteredReconIndex, filteredRecon]);

   useEffect(() => {
      const handleClickOutside = (event) => {
         if (supplierDatePickerRef.current && !supplierDatePickerRef.current.contains(event.target)) {
            setShowCalendar(false);
         }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
   }, []);
   // Function to calculate the arrow's position
   const calculateBoxPosition = (vertices, scale, pageWidth, pageHeight, canvasOffset) => {
      if (!isEdit || !pageWidth || !pageHeight) return { top: 0, left: 0, width: 0, height: 0 };

      // Get the X and Y positions relative to the PDF document
      const pdfTop = vertices[0].y * pageHeight; // Convert to absolute position
      const height = (vertices[2].y - vertices[1].y) * pageHeight;

      // Ensure X position starts where the canvas starts
      const adjustedLeft = canvasOffset.pdfLeftOffset; // Always start at the canvas left position

      // Ensure Width is the full width of the canvas (PDF)
      const adjustedWidth = pageWidth * scale; // Full width of the PDF scaled

      // Adjust for scaling and position inside Offcanvas
      const adjustedTop = pdfTop * scale + canvasOffset.top - scrollRef.current;

      return {
         top: adjustedTop, // Position inside PDF
         left: adjustedLeft, // Centered offset
         width: adjustedWidth, // Scale the width
         height: height * scale, // Scale the height
      };
   };

   useEffect(() => {
      //if (!isEdit || !pageDimensions.width || !pageDimensions.height || !filteredRecon[filteredReconIndex]?.sd_invoice_date_obj?.normalized_vertices) return;

      if (!isEdit || !pageDimensions.width || !pageDimensions.height || !Array.isArray(filteredRecon[filteredReconIndex]?.sd_invoice_date_obj?.normalized_vertices) || filteredRecon[filteredReconIndex]?.sd_invoice_date_obj?.normalized_vertices.length === 0) {
         // Either no vertices or invalid, so clear boxPosition
         setBoxPosition(null);
         return;
      }

      const newNormalizedVertices = filteredRecon[filteredReconIndex].sd_invoice_date_obj.normalized_vertices;
      const newBoxPosition = calculateBoxPosition(newNormalizedVertices, scale, pageDimensions.width, pageDimensions.height, canvasOffset);

      setBoxPosition(newBoxPosition); // Store in state to trigger re-render
   }, [isEdit, scale, pageDimensions, canvasOffset, scrollRef.current, filteredReconIndex, filteredRecon]);

   useEffect(() => {
      if (canvasRef.current) {
         const offcanvasElement = document.querySelector(".offcanvas.show"); // Get the Offcanvas element manually
         const canvasElement = canvasRef.current.getBoundingClientRect();

         if (!offcanvasElement) {
            console.warn("⚠️ Offcanvas element not found!");
            return;
         }

         const offcanvasRect = offcanvasElement.getBoundingClientRect();
         const canvasLeft = canvasElement.left; // PDF starting position inside Offcanvas

         const offcanvasLeft = offcanvasRect.left; // Get Offcanvas starting position
         const offcanvasWidth = width;

         const pdfWidth = (pageDimensions.width || 0) * scale; // Adjusted PDF width with zoom

         if (offcanvasWidth === 0 || pdfWidth === 0) {
            console.warn("Missing dimensions! Offcanvas or PDF width is 0.");
            return;
         }

         const centreOffset = (offcanvasWidth - pdfWidth) / 2; // Adjust for centering
         const pdfLeftOffset = canvasLeft - offcanvasLeft; // Corrected PDF start position

         console.log("Updated Offcanvas Offsets:", {
            offcanvasWidth,
            offcanvasLeft,
            pdfWidth,
            centreOffset,
            pdfLeftOffset,
            canvasLeft,
         });

         setCanvasOffset({
            left: centreOffset,
            top: canvasRef.current.offsetTop || 0,
            pdfLeftOffset: pdfLeftOffset, // Now scales with zoom
         });

         // Recalculate the box position when Offcanvas width changes
         //if (normalizedVertices) {
         if (Array.isArray(normalizedVertices) && normalizedVertices.length >= 2) {
            const newBoxPosition = calculateBoxPosition(normalizedVertices, scale, pageDimensions.width, pageDimensions.height, {
               left: centreOffset,
               top: canvasRef.current.offsetTop || 0,
               pdfLeftOffset: pdfLeftOffset,
            });

            // setBoxPosition(newBoxPosition);
            if (newBoxPosition) setBoxPosition(newBoxPosition);
         } else {
            // Fallback: No highlight box
            console.log("⚠️ Skipping box overlay – invalid or empty normalizedVertices.");
            setBoxPosition(null);
         }
      }
   }, [scale, pageDimensions, width]);

   //const boxPosition = calculateBoxPosition(normalizedVertices.normalized_vertices, scale, pageDimensions.width, pageDimensions.height, canvasOffset);

   const onClose = (e) => {
      setShow(false);
      onCloseModal?.();
   };

   const handleMouseDown = () => {
      setIsDragging(true);
      document.body.classList.add("bc-dragging");
   };

   const handleFlagSelect = (detailId, selectedValue) => {
      console.log("FLAG SELECTED:", detailId, selectedValue);
      if ((selectedValue = "-1")) {
      }
   };

   const handleMouseMove = (e) => {
      // Cancel any pending RAF to avoid multiple updates
      if (dragRef.current) cancelAnimationFrame(dragRef.current);

      // Use RAF for smoother animation
      dragRef.current = requestAnimationFrame(() => {
         const newWidth = Math.min(Math.max(200, window.innerWidth - e.clientX), window.innerWidth * 0.8);
         setWidth(newWidth);

         if (normalizedVertices) {
            const newBoxPosition = calculateBoxPosition(normalizedVertices, scale, pageDimensions.width, pageDimensions.height, {
               left: (newWidth - (pageDimensions.width || 0) * scale) / 2,
               top: canvasRef.current.offsetTop || 0,
               pdfLeftOffset: canvasRef.current.getBoundingClientRect().left - document.querySelector(".offcanvas.show")?.getBoundingClientRect().left || 0,
            });

            setBoxPosition(newBoxPosition);
         }
      });
   };

   const handleMouseUp = () => {
      setIsDragging(false);
      document.body.classList.remove("bc-dragging");
      // Ensure cleanup of the RAF reference
      if (dragRef.current) {
         cancelAnimationFrame(dragRef.current);
         dragRef.current = null;
      }
   };

   useEffect(() => {
      if (isDragging) {
         window.addEventListener("mousemove", handleMouseMove);
         window.addEventListener("mouseup", handleMouseUp);
      } else {
         window.removeEventListener("mousemove", handleMouseMove);
         window.removeEventListener("mouseup", handleMouseUp);
      }
      return () => {
         window.removeEventListener("mousemove", handleMouseMove);
         window.removeEventListener("mouseup", handleMouseUp);
      };
   }, [isDragging]);

   // Ensure the width is always 50% when the component mounts
   useEffect(() => {
      const handleResize = () => {
         setWidth(window.innerWidth * 0.5); // Adjust to 50% of the viewport
      };

      window.addEventListener("resize", handleResize);
      return () => {
         window.removeEventListener("resize", handleResize);
      };
   }, []);

   const zoomIn = () => setScale(scale + 0.2);
   const zoomOut = () => setScale(scale - 0.2);
   const actualSize = () => setScale(1.0);
   const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
      setPageNo(pageNumber);
   };

   const handleDocumentLoadSuccess = (pdf) => {
      setNumPages(pdf.numPages);
      setCurrentPage(pageNo);

      // Fetch the first page to get its dimensions
      pdf.getPage(pageNo).then((page) => {
         const { view } = page;
         setPageDimensions({
            width: view[2], // Width of the page
            height: view[3], // Height of the page
         });

         console.log("PDF Loaded:", {
            numPages: pdf.numPages,
            width: view[2],
            height: view[3],
         });
      });
   };

   const handleScroll = (event) => {
      scrollRef.current = event.target.scrollTop; // Store scroll position instantly

      setBoxPosition((prevPosition) => {
         if (!prevPosition) return null;
         return {
            ...prevPosition,
            top: prevPosition.top - scrollRef.current, // Adjust for scrolling
         };
      });
   };

   const handleSupplierInvoiceNumber = (value) => {
      const newValue = value.target?.value ?? value;
      setFormData((prev) => ({ ...prev, supplierInvoiceNumber: newValue }));
      supplierInvoiceNumberRef.current = newValue;
   };
   const handleSupplierPONumber = (value) => {
      const newValue = value.target?.value ?? value;
      setFormData((prev) => ({ ...prev, supplierPONumber: newValue }));
      supplierPONumberRef.current = newValue;
   };
   const handleExternalInvoiceNumber = (value) => {
      const newValue = value.target?.value ?? value;
      setFormData((prev) => ({ ...prev, externalInvoiceNumber: newValue }));
      externalInvoiceNumberRef.current = newValue;
   };
   const handleExternalPONumber = (value) => {
      const newValue = value.target?.value ?? value;
      setFormData((prev) => ({ ...prev, externalPONumber: newValue }));
      externalPONumberRef.current = newValue;
   };
   const handleSupplierInvoiceDate = (date) => {
      if (date instanceof Date && !isNaN(date)) {
         // Convert the date to YYYY-MM-DD in UTC to avoid local timezone issues
         const normalizedDate = format(date, "yyyy-MM-dd", { timeZone: "UTC" });
         setSupplierInvoiceDate(date); // Keep the Date object for DatePicker
         supplierInvoiceDateRef.current = normalizedDate; // Store as YYYY-MM-DD string
      } else {
         setSupplierInvoiceDate(null);
         supplierInvoiceDateRef.current = "";
      }
   };
   useEffect(() => {
      console.log("DatePicker render - supplierInvoiceDateRef.current:", supplierInvoiceDateRef.current);
   }, [supplierInvoiceDateRef.current]);

   const handleManualSupplierInvoiceDate = (e) => {
      supplierInvoiceDateRef.current = e.target.value;
   };
   const handleBlurSupplierInvoiceDate = () => {
      const parsedDate = parseDate(supplierInvoiceDateRef.current);
      if (parsedDate) {
         setSupplierInvoiceDate(parsedDate);
         supplierInvoiceDateRef.current = formatDate(parsedDate);
      } else {
         supplierInvoiceDateRef.current = "";
         setSupplierInvoiceDate(null);
      }
   };

   const handleExternalInvoiceDate = (value) => {
      setExternalInvoiceDate(value);
   };
   const handleManualExternalInvoiceDate = (e) => {
      setExternalInvoiceDate(e.target.value);
   };

   const handleSupplierInvoiceAmount = (value) => {
      setFormData((prev) => ({ ...prev, supplierInvoiceAmount: value }));
      supplierInvoiceAmountRef.current = value;
   };
   const handleExternalInvoiceAmount = (value) => {
      setFormData((prev) => ({ ...prev, externalInvoiceAmount: value }));
      externalInvoiceAmountRef.current = value;
   };

   const handleIgnoreSupplierCheckboxChange = (e) => {
      const isChecked = e.target.checked;
      setFormData((prev) => ({ ...prev, ignoreSupplier: isChecked }));
      ignoreSupplierRef.current = isChecked;
   };
   const handleIgnoreEntryCheckboxChange = (e) => {
      const isChecked = e.target.checked;
      setFormData((prev) => ({ ...prev, ignoreEntry: isChecked }));
      ignoreEntryRef.current = isChecked;
   };

   //const handleFollowUpStatusChange = (status) => {
   //   console.log("handleFollowUpStatusChange", status);
   //   setHasFollowUp(status);
   //};
   const handleFollowUpStatusChange = (status) => {
      console.log(`Follow-up status updated at index ${filteredReconIndex}:`, status);
      setHasFollowUp(status);

      // Send the update to the parent, including the current `filteredReconIndex`
      if (onFollowUpStatusChange) {
         onFollowUpStatusChange(status, filteredReconIndex);
      }
   };

   // Parses YYYY-MM-DD into a Date object in UTC
   const parseDate = (input) => {
      if (!input) return null;
      const parts = input.split("-");
      if (parts.length === 3) {
         const [y, m, d] = parts;
         // Create a Date object in UTC
         const parsed = new Date(Date.UTC(parseInt(y), parseInt(m) - 1, parseInt(d)));
         console.log("parseDate input:", input, "parsed UTC:", parsed.toISOString());
         return isNaN(parsed.getTime()) ? null : parsed;
      }
      return null;
   };

   const parseLocalDateFromString = (str) => {
      if (!str) return null;
      if (str instanceof Date) return isNaN(str.getTime()) ? null : str;
      if (typeof str !== "string") return null;

      // Supports "YYYY-MM-DD" and ISO-like strings
      if (str.includes("-")) {
         const datePart = str.split("T")[0];
         const [year, month, day] = datePart.split("-").map(Number);
         const parsed = new Date(year, month - 1, day);
         return isNaN(parsed.getTime()) ? null : parsed;
      }

      // Supports compact "YYYYMMDD"
      if (/^\d{8}$/.test(str)) {
         const year = Number(str.slice(0, 4));
         const month = Number(str.slice(4, 6));
         const day = Number(str.slice(6, 8));
         const parsed = new Date(year, month - 1, day);
         return isNaN(parsed.getTime()) ? null : parsed;
      }

      return null;
   };

   // Formats Date object into YYYY-MM-DD string in UTC
   const formatDate = (input) => {
      if (!input) return "";
      const date = input instanceof Date ? input : parseDate(input);
      if (isNaN(date.getTime())) return "";
      return format(date, "yyyy-MM-dd", { timeZone: "UTC" });
   };

   const handleNext = () => {
      if (!isNextDisabled && nextPageExists) {
         setfilteredReconIndex(filteredReconIndex + 1);
      }
   };
   const handlePrevious = () => {
      if (!isPrevDisabled && prevPageExists) {
         setfilteredReconIndex(filteredReconIndex - 1);
      }
   };

   function formatDateToYYYYMMDD(date) {
      return date instanceof Date && !isNaN(date) ? format(date, "yyyy-MM-dd") : "";
   }

   // Check if the next page exists
   const nextPageExists = filteredReconIndex + 1 < filteredRecon.length;
   const prevPageExists = filteredReconIndex - 1 >= 0;

   // Get the `sd_page_no` for the next and previous pages
   const nextPageNumber = nextPageExists ? filteredRecon[filteredReconIndex + 1]?.sd_page_no : null;
   const prevPageNumber = prevPageExists ? filteredRecon[filteredReconIndex - 1]?.sd_page_no : null;

   // Disable navigation when `isEdit` is true and the next/previous page number is different from the original
   const isNextDisabled = isEdit && nextPageNumber !== originalPageNumber;
   const isPrevDisabled = isEdit && prevPageNumber !== originalPageNumber;

   const handleSubmitOverride = async () => {
      setIsLoading(true);

      const url = "/update_reconcile_edit.sz";
      const method = "POST";
      const formData = new FormData();
      formData.append("_sd_invoice_number", supplierInvoiceNumberRef.current);
      formData.append("_sd_po_number", supplierPONumberRef.current);
      formData.append("_sd_invoice_date", supplierInvoiceDateRef.current);
      formData.append("_sd_invoice_amount", supplierInvoiceAmountRef.current);
      formData.append("_sd_id", supplierDetailID);
      formData.append("_s_id", statementID);
      formData.append("_esh_id", externalSourceHeaderID);
      formData.append("_ignore_supplier", ignoreSupplierRef.current);
      formData.append("_ignore_entry", ignoreEntryRef.current);

      try {
         const { responseData, fetchLoading, fetchError } = await fetchData(url, method, formData, "form-data");
         if (responseData.st === 1) {
            if (responseData.payload.length > 0) {
               const updatedReconItem = responseData.payload[0];

               // Merge the updated data into the filteredRecon array, as we need to passit back to the reconcile.js
               console.log("BEFORE UPDATE:", updatedReconItem);

               const updatedFilteredRecon = filteredRecon.map((item) => (item.sd_id === updatedReconItem.sd_id ? { ...item, ...updatedReconItem } : item));

               console.log(
                  "AFTER UPDATE:",
                  updatedFilteredRecon.find((item) => item.sd_id === updatedReconItem.sd_id)
               );

               setMatchStatus(updatedReconItem?.match_status);
               console.log("match status", updatedReconItem?.match_status);

               console.log("SEND BACK:", updatedFilteredRecon);
               // Call the parent's callback with the updated array
               onUpdateReconData?.(updatedFilteredRecon);
            }
         } else {
            const e = `Hmmm, we have experienced an issue. ${responseData.mg} `;
            triggerToast("error", e, false, "Session Issue", false, 0);
         }
      } catch (error) {
         triggerToast("error", "We are experiencing connectivity issues, please try again later.", true, "Network Issue", false, 0);
      } finally {
         setIsLoading(false);
      }
   };

   const invoiceFormJSX = (
         <div className="d-flex">
            <div className="d-flex flex-grow-1 justify-content-center">
               <div className="d-flex  align-items-center">
                  <div className="container override-form">
                     <Form>
                        <Row className="d-flex flex-nowrap h-100">
                           <Col className="flex-fill" style={{ width: "690px", marginLeft: "20px" }}>
                              <Row className="align-items-center mb-3">
                                 <div className="rec-inv-stat-pdf-col label mt-4" style={{ width: "90px", flex: "none" }}>
                                    <span className="label-text d-flex justify-content-end text-end flex-wrap me-2">
                                       Supplier
                                       <br />
                                       Statement
                                    </span>
                                 </div>
                                 <div className="rec-inv-stat-pdf-col input" style={{ width: "155px", flex: "none" }}>
                                    <Form.Group controlId="supplierInvoiceNumber">
                                       <Form.Label>Invoice Number</Form.Label>
                                       <Form.Control className="mt-2" type="text" placeholder="Invoice Number" value={formData.supplierInvoiceNumber} onChange={handleSupplierInvoiceNumber} />
                                    </Form.Group>
                                 </div>
                                 <div className="rec-inv-stat-pdf-col input" style={{ width: "155px", flex: "none" }}>
                                    <Form.Group controlId="supplierPONumber">
                                       <Form.Label>P/O Number</Form.Label>
                                       <Form.Control className="mt-2" type="text" placeholder="P/O" value={formData.supplierPONumber} onChange={handleSupplierPONumber} />
                                    </Form.Group>
                                 </div>
                                 <div ref={supplierDatePickerRef} className="rec-inv-stat-pdf-col input" style={{ width: "155px", flex: "none" }}>
                                    <Form.Group controlId="supplierInvoiceDate">
                                       <Form.Label>Invoice Date</Form.Label>
                                       <Form.Control type="text" value={supplierInvoiceDateRef.current} onChange={handleManualSupplierInvoiceDate} onBlur={handleBlurSupplierInvoiceDate} placeholder="YYYY-MM-DD" className="mt-2" onFocus={() => setShowCalendar(true)} />

                                       {showCalendar && (
                                          <div className="position-absolute bg-white border rounded shadow p-2 mt-1 z-3">
                                             {(() => {
                                                const selectedInvoiceDate = parseLocalDateFromString(supplierInvoiceDateRef.current) || (supplierInvoiceDate instanceof Date ? supplierInvoiceDate : undefined);
                                                return (
                                             <DayPicker
                                                mode="single"
                                                selected={selectedInvoiceDate}
                                                defaultMonth={selectedInvoiceDate}
                                                onSelect={(date) => {
                                                   setShowCalendar(false);
                                                   handleSupplierInvoiceDate(date);
                                                   supplierInvoiceDateRef.current = formatDateToYYYYMMDD(date);
                                                }}
                                             />
                                                );
                                             })()}
                                          </div>
                                       )}
                                    </Form.Group>
                                 </div>
                                 <div className="rec-inv-stat-pdf-col input pe-0" style={{ width: "155px", flex: "none" }}>
                                    <Form.Group controlId="supplierInvoiceAmount">
                                       <Form.Label>Invoice Amount</Form.Label>
                                       <CurrencyInput value={formData.supplierInvoiceAmount} onAmountChange={handleSupplierInvoiceAmount} className="mt-2" />
                                    </Form.Group>
                                 </div>
                                 <div className="rec-inv-stat-pdf-col connector d-flex align-items-start">
                                    <div className="horizontal-line" style={{ marginTop: "15px" }}></div>
                                    <div className="vertical-top-line"></div>
                                 </div>
                              </Row>
                              <Row className="align-items-center">
                                 <div className="rec-inv-stat-pdf-col d-flex justify-content-end text-end label" style={{ width: "90px", flex: "none" }}>
                                    <span className="label-text flex-wrap">
                                       Protractor
                                       <br />
                                       Entry
                                    </span>
                                 </div>
                                 <div className="rec-inv-stat-pdf-col input" style={{ width: "155px", flex: "none" }}>
                                    <Form.Group controlId="entryInvoiceNumber">
                                       <Form.Control type="text" className="mt-2" placeholder="Invoice Number" value={formData.externalInvoiceNumber} onChange={handleExternalInvoiceNumber} readOnly style={readOnlyStyle} />
                                    </Form.Group>
                                 </div>
                                 <div className="rec-inv-stat-pdf-col input" style={{ width: "155px", flex: "none" }}>
                                    <Form.Group controlId="entryPONumber">
                                       <Form.Control type="text" className="mt-2" placeholder="P/O Number" value={formData.externalPONumber} onChange={handleExternalPONumber} readOnly style={readOnlyStyle} />
                                    </Form.Group>
                                 </div>
                                 <div className="rec-inv-stat-pdf-col input" style={{ width: "155px", flex: "none" }}>
                                    <Form.Group controlId="entryInvoiceDate">
                                       <Form.Control type="text" value={externalInvoiceDate} placeholder="YYYY-MM-DD" className="mt-2" style={readOnlyStyle} readOnly={true} />
                                    </Form.Group>
                                 </div>
                                 <div className="rec-inv-stat-pdf-col input pe-0" style={{ width: "155px", flex: "none" }}>
                                    <Form.Group controlId="entryInvoiceAmount">
                                       <CurrencyInput value={formData.externalInvoiceAmount} onChange={handleExternalInvoiceAmount} className="mt-2" readOnly={true} />
                                    </Form.Group>
                                 </div>
                                 <div className="rec-inv-stat-pdf-col connector d-flex align-items-start">
                                    <div className="horizontal-line" style={{ marginTop: "0px" }}></div>

                                    {ignoreEntryRef.current || ignoreSupplierRef.current ? null : matchStatus === "MATCHED" || matchStatus === "FULL_MATCH" ? <FaEquals size={16} color="green" className="icon-connector" /> : matchStatus === "PARTIAL" ? <FaNotEqual size={16} color="orange" className="icon-connector" /> : matchStatus === "UNMATCHED" ? <FaTimes size={16} color="red" className="icon-connector" /> : matchStatus === "NO_ERP" ? <FaTimes size={16} color="red" className="icon-connector" /> : null}
                                    <div className="vertical-bottom-line"></div>
                                 </div>
                              </Row>
                           </Col>
                           <Col className="d-flex flex-column align-items-center ps-0 pe-0">
                              <Row>
                                 <Form.Label>Ignore</Form.Label>
                              </Row>
                              <Row style={{ marginTop: "20px" }}>
                                 <Form.Check type="checkbox" id="ignoreSupplierInvoice" className="" checked={formData.ignoreSupplier} onChange={handleIgnoreSupplierCheckboxChange} disabled={!supplierDetailID} />
                              </Row>
                              <Row></Row>
                              <Row style={{ marginTop: "30px" }}>
                                 <Form.Check type="checkbox" id="ignoreEntryInvoice" className="" checked={formData.ignoreEntry} onChange={handleIgnoreEntryCheckboxChange} disabled={externalSourceHeaderID ? false : true} />
                              </Row>
                           </Col>
                           <Col className="d-flex flex-column justify-content-center mb-4 h-100 gap-3">
                              <Row style={{ marginTop: "35px" }}>
                                 <button
                                    className="btn btn-outline-secondary rounded-pill pt-1 pb-1 d-flex align-items-center"
                                    type="button"
                                    disabled={isNextDisabled}
                                    onClick={handleNext}>
                                    Next <FaArrowRight className="ms-2" />
                                 </button>
                                 <button
                                    className="btn btn-outline-secondary rounded-pill pt-1 pb-1 mt-3 d-flex align-items-center"
                                    type="button"
                                    disabled={isPrevDisabled}
                                    onClick={handlePrevious}>
                                    <FaArrowLeft className="me-2" /> Prev
                                 </button>
                              </Row>
                           </Col>
                        </Row>
                     </Form>
                  </div>
               </div>
            </div>
         </div>
   );

   return (
      <>
         <Offcanvas
            onEntered={() => {
               if (offcanvasRef.current) {
                  const offcanvasElement = document.querySelector(".offcanvas.show");
                  if (offcanvasElement) {
                     const offcanvasLeft = offcanvasElement.getBoundingClientRect().left; // Get absolute left position
                     const offcanvasWidth = offcanvasElement.offsetWidth; // Get width of Offcanvas

                     setCanvasOffset((prev) => ({
                        ...prev,
                        offcanvasWidth: offcanvasWidth || 0,
                        offcanvasLeft: offcanvasLeft || 0, // Store the starting position of Offcanvas
                     }));
                     console.log("Offcanvas Width:", offcanvasWidth);
                     console.log("Offcanvas Left:", offcanvasLeft || 0);
                  }
               }
            }}
            style={{
               width: `${width}px`,
               position: "fixed", // Keep fixed positioning
               minWidth: "980px", // set to a minimum
               top: 0,
               right: 0,
               height: "100vh",
               overflow: "hidden",
            }}
            ref={offcanvasRef}
            className=""
            onHide={onClose}
            show={show}
            scroll={true}
            backdrop={false}
            placement="end">
            <div
               className="draggable-grip"
               style={{
                  position: "absolute",
                  top: "50%",
                  left: "-13px", // Align slightly outside the offcanvas for visibility
                  transform: "translateY(-50%)",
                  cursor: "ew-resize",
                  zIndex: 1055, // Ensure it's above the offcanvas content
               }}
               onMouseDown={handleMouseDown}>
               <FaGripLinesVertical size={24} />
            </div>
            <Offcanvas.Header className="me-3" closeButton>
               {isEdit && (
                  <>
                     <Row className="d-flex align-items-center justify-content-end me-3 w-100">
                        <Col ref={headerColWidthRef} className={`d-flex align-items-center justify-content-start gap-3 ${!isHeaderColWidth ? "" : "header-col-hide"}`}>
                           <div className="d-flex align-items-center">
                              <FaRegFilePdf size={14} className="me-2" />
                              <span className="fs-13 text-muted">
                                 page <span className="">1</span> <small>of</small> 2
                              </span>
                           </div>
                           <div className="d-flex align-items-center">
                              <FaDotCircle size={7} color="#e2e5ec" />
                           </div>
                           <div className="d-flex align-items-center ms-1">
                              <FaRegStar size={14} className="me-2" />
                              <span className="fs-13 text-muted">
                                 grade <span className="">{documentGrade}</span>
                              </span>
                           </div>
                           <div className="d-flex align-items-center">
                              <FaDotCircle size={7} color="#e2e5ec" />
                           </div>
                           <div className="d-flex align-items-center ms-1 text-muted">
                              {/* If we have no reconciliation, check supplier override, if not check protractor entry */}
                              {filteredRecon[filteredReconIndex]?.rc_id ? (
                                 <>
                                    <small className="text-muted">
                                       Reconciled On {format(parseISO(filteredRecon[filteredReconIndex]?.rc_date), "yyyy-MM-dd HH:mm")} by {filteredRecon[filteredReconIndex]?.rc_user_name}
                                    </small>
                                 </>
                              ) : filteredRecon[filteredReconIndex]?.sup_state_detail_ovr_update_on ? (
                                 <>
                                    <small className="text-muted me-1">
                                       Override Supplier On {format(parseISO(filteredRecon[filteredReconIndex]?.sup_state_detail_ovr_update_on), "yyyy-MM-dd HH:mm")} by {filteredRecon[filteredReconIndex]?.sd_user_name}
                                    </small>
                                 </>
                              ) : filteredRecon[filteredReconIndex]?.en_insert_on ? (
                                 <>
                                    <small className="text-muted me-1">
                                       Protractor Entry On {format(parseISO(filteredRecon[filteredReconIndex]?.en_insert_on), "yyyy-MM-dd HH:mm")} by {filteredRecon[filteredReconIndex]?.en_user_name}
                                    </small>
                                 </>
                              ) : (
                                 ""
                              )}
                           </div>
                        </Col>
                        <Col xs="auto" className="text-center">
                           <Button variant="link" className="p-0 border-0" style={{ textDecoration: "none" }} onClick={() => setShowFollowup(true)}>
                              {hasFollowUp ? <FaFlag size={20} color="orange" /> : <FaRegFlag size={20} />}
                           </Button>
                        </Col>
                        <Col xs="auto" className="text-center">
                           <button className="btn btn-primary rounded-pill ms-3 pt-1 pb-1" onClick={handleSubmitOverride} type="button">
                              Save Override
                           </button>
                        </Col>
                     </Row>
                  </>
               )}
            </Offcanvas.Header>
            <Offcanvas.Body
               style={{
                  overflow: "hidden", // Prevent overflow on the Offcanvas.Body
                  paddingTop: "0px",
               }}>
               {isEdit && (
                  <>
                     <Row>
                        <Col>
                           <div className="container-fluid" style={{ overflowX: "auto", whiteSpace: "nowrap", width: "100%", overflow: "visible" }}>
                              {invoiceFormJSX}
                           </div>
                        </Col>
                     </Row>
                     <hr />
                  </>
               )}
               <div>
                  <Row>
                     <Col md={12}>
                        <div className="d-flex justify-content-between mb-3">
                           <div>
                              <FaSearchPlus size={22} onClick={zoomIn} title="Zoom In" style={{ cursor: "pointer" }} className="me-3" />
                              <FaSearchMinus size={22} onClick={zoomOut} title="Zoom Out" style={{ cursor: "pointer" }} className="me-3" />
                              <FaCompress size={22} onClick={actualSize} title="Actual Size" style={{ cursor: "pointer" }} />
                           </div>
                           <div className="d-flex flex-column justify-content-center align-items-center text-center">
                              <div className="text-muted">
                                 <small>Uploaded On</small> 2024-12-25 01:13 PM <small>by</small> Dimitri Palantzas
                              </div>
                              <div className="text-muted">
                                 <small>File</small> 1552618-123123.pdf
                              </div>
                           </div>
                           <div className="d-flex align-items-center">
                              <button
                                 className="btn btn-link fs-5 pe-1"
                                 onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                                 disabled={currentPage === 1 || isEdit} // Disable on first page or we have override form
                              >
                                 <FaArrowUp size={20} />
                              </button>
                              <input
                                 type="number"
                                 className="form-control text-center"
                                 value={currentPage}
                                 disabled={isEdit} // disable input for override form
                                 onChange={(e) => {
                                    let newPage = e.target.value; // Allow temporary invalid values
                                    if (newPage === "" || (!isNaN(newPage) && newPage >= 1 && newPage <= numPages)) {
                                       setCurrentPage(newPage);
                                    }
                                 }}
                                 onBlur={(e) => {
                                    let newPage = parseInt(e.target.value, 10);
                                    if (isNaN(newPage) || newPage < 1) {
                                       setCurrentPage(1); // Reset to 1 if below range
                                    } else if (newPage > numPages) {
                                       setCurrentPage(numPages); // Reset to last page if above range
                                    } else {
                                       setCurrentPage(newPage);
                                    }
                                 }}
                                 onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                       let newPage = parseInt(e.target.value, 10);
                                       if (!isNaN(newPage) && newPage >= 1 && newPage <= numPages) {
                                          handlePageChange(newPage);
                                          e.target.blur();
                                       }
                                    }
                                 }}
                                 style={{ width: "50px", margin: "0 5px" }}
                              />
                              <span className="text-muted"> of {numPages}</span>
                              <button
                                 className="btn btn-link fs-5 pe-1"
                                 onClick={() => handlePageChange(Math.min(numPages, currentPage + 1))}
                                 disabled={currentPage === numPages || isEdit} // Disable on last page or we have an override form
                              >
                                 <FaArrowDown size={20} />
                              </button>
                           </div>
                        </div>
                        <div
                           onScroll={handleScroll}
                           className="d-flex flex-column align-items-center pt-4 "
                           style={{
                              overflowY: "auto", // Enable vertical scrolling
                              overflowX: "hidden", // Disable horizontal scrolling
                              maxHeight: `calc(100vh - ${isEdit ? "350px" : "100px"})`, // Adjust this value to account for any header, footer, or controls
                              width: "100%", // Ensure the div spans the full width of its container
                              clipPath: "inset(0px 0px 0px 0px)", // Prevents the box from leaking out
                           }}>
                           <div ref={canvasRef} style={{ position: "relative", display: "inline-block" }}>
                              <Document file={`data:application/pdf;base64,${imageData}`} onLoadSuccess={handleDocumentLoadSuccess}>
                                 <Page
                                    pageNumber={pageNo}
                                    scale={scale}
                                    renderTextLayer={false} // Disable text layer
                                    renderAnnotationLayer={false} // Disable annotation layer
                                    style={{ width: "100%" }}
                                 />
                              </Document>
                           </div>
                           {boxPosition && boxPosition.width > 0 && boxPosition.height > 0 && (
                              <div
                                 className="box-overlay"
                                 style={{
                                    position: "absolute",
                                    top: `${boxPosition.top}px`,
                                    left: `${boxPosition.left}px`,
                                    width: `${boxPosition.width}px`,
                                    height: `${boxPosition.height}px`,
                                    border: "none",
                                    backgroundColor: "rgba(255, 165, 0, 0.3)",
                                    zIndex: 1000,
                                    pointerEvents: "none", // Prevents the box from interfering with clicks
                                 }}></div>
                           )}
                        </div>
                     </Col>
                  </Row>
               </div>
            </Offcanvas.Body>
         </Offcanvas>
         {showFollowup && <FollowUpModal sdId={supplierDetailID} eshId={externalSourceHeaderID} supplierInvoiceNumber={formData.supplierInvoiceNumber} externalInvoiceNumber={formData.externalInvoiceNumber} onFollowUpStatusChange={handleFollowUpStatusChange} onCloseModal={() => setShowFollowup(false)} />}
      </>
   );
};

function calculateDisplayedPages(currentPage, numPages, maxDisplayedPages = 1000) {
   if (!numPages) return [];

   const range = Math.min(maxDisplayedPages, numPages);
   const half = Math.floor(range / 2);
   let start = Math.max(currentPage - half, 1);
   let end = Math.min(start + range - 1, numPages);

   if (end - start < range - 1) {
      start = Math.max(end - range + 1, 1);
   }

   const pages = [];
   for (let i = start; i <= end; i++) {
      pages.push(i);
   }

   return pages;
}

export default ReconcileInvoiceStatementPdfModal;
